import { EducationMockForDev } from "app/components/educationbar/educationMock";

import { fetchJsonWithSentry } from "../bootstrap-utils";

const educationURL = {
    east: "https://test.groupbuyclub.net/_sub_static_education_east/education.json",
    west: "https://test.groupbuyclub.net/_sub_static_education/education.json",
};

export function initEducation(): void {
    const isWest = (window.assetsRoot ?? "").includes("west");

    if (process.env.NODE_ENV === "development") {
        window.education = EducationMockForDev;
        return;
    }

    window.education = {};
    const url = isWest ? educationURL.west : educationURL.east;
    void fetchJsonWithSentry(url, { fallbackValue: {}, resourceName: "education.json" }).then((data) => {
        window.education = data;
    });
}
